module.exports = __webpack_public_path__ + "img/sideflag.02b2752.png";